import { createAction } from "@reduxjs/toolkit";
import { createRsaaAction } from "../../components/utilities/ReduxUtils";
import type { LicenseInfoResponse } from "../../data/models/schemas";

export const GET_USER_LICENSE: string = "GET_USER_LICENSE";
export const USER_LOGIN: string = "USER_LOGIN";
export const USER_LOGOUT: string = "USER_LOGOUT";
export const USER_SET_REMAINING_UNITS = "USER_SET_REMAINING_UNITS";

export type IUserLoginRequest = {
    email: string;
    password?: string;
    force?: boolean;
};

export const logIn = createRsaaAction<IUserLoginRequest>({
    path: "login",
    method: "POST",
    type: USER_LOGIN,
});

export const logOut = createRsaaAction({
    path: "logout",
    method: "POST",
    type: USER_LOGOUT,
});

export type IUserLicenseInfoResponse = LicenseInfoResponse;

export const getUserLicenseInfo = createRsaaAction<
    void,
    IUserLicenseInfoResponse
>({
    path: "users/license",
    method: "GET",
    type: GET_USER_LICENSE,
});

export const setRemainingUnits = createAction<number>(USER_SET_REMAINING_UNITS);
